<ng-container *ngIf="config.segments.length>0">
    <div [ngClass]="config.class">
        <ion-segment>
                <ng-container *ngFor="let segment of config.segments; let index = index">
                    <ng-container *ngIf="segment.link else button">
                            <ion-segment-button (click)="presentPopover($event, segment.tooltip, segment.tooltipClass); gatemanService.routeHub(segment.link); ">
                                    <fa-icon [icon]="segment.icon" *ngIf="segment.icon"></fa-icon>
                                    <ion-label *ngIf="segment.title">{{segment.title}}</ion-label>
                            </ion-segment-button>
                    </ng-container>
                    <ng-template #button>
                            <ion-segment-button>
                                    <fa-icon [icon]="segment.icon" *ngIf="segment.icon"></fa-icon>
                                    <ion-label *ngIf="segment.title">{{segment.title}}</ion-label>
                            </ion-segment-button>
                    </ng-template>
                </ng-container>
        </ion-segment>
    </div>
</ng-container>